import Link from "next/link";
import styles from "../../styles/CategoryChips.module.css";

// Phone-only row of shortcuts under the header (hidden on desktop in the CSS): the side menu's top items
// first, then popular categories. Computers get the same links as a card row (QuickNav.js).
const CHIPS = [
  { name: "New", icon: "new-games", url: "/categories/new-games" },
  { name: "Trending", icon: "trending", url: "/categories/trending-games" },
  { name: "Rising", icon: "rising", url: "/categories/rising-games" },
  { name: "Most Played", icon: "most-played", url: "/categories/popular-games" },
  { name: "Exclusive", icon: "exclusive", url: "/categories/exclusive-games" },
  { name: "Recently Played", icon: "recently-played", url: "/recently-played" },
  { name: "Dress Up", icon: "dressup", url: "/categories/dress-up-games" },
  { name: "K-Pop", icon: "kpop", url: "/categories/kpop-dress-up-games" },
  { name: "Princess", icon: "princess", url: "/categories/princess-games" },
  { name: "Aesthetic", icon: "aesthetic", url: "/categories/aesthetic-dress-up-games" },
  { name: "Make Up", icon: "makeup", url: "/categories/makeover-games" },
  { name: "Celebrity", icon: "celebrity", url: "/categories/celebrity-games" },
  { name: "Frozen", icon: "frozen", url: "/categories/frozen-games" },
  { name: "Cooking", icon: "cooking", url: "/categories/cooking-games" },
];

export default function CategoryChips() {
  return (
    <nav className={styles.band} aria-label="Popular categories">
      <div className={styles.row}>
        {CHIPS.map((chip) => (
          <Link key={chip.url} href={chip.url} prefetch={false} className={styles.chip}>
            <img src={`/assets/sidenav/v2/${chip.icon}.svg`} alt="" width="20" height="20" />
            {chip.name}
          </Link>
        ))}
      </div>
    </nav>
  );
}
